import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-addtranspaymode',
  templateUrl: './addtranspaymode.component.html',
  styleUrls: ['./addtranspaymode.component.css']
})
export class AddtranspaymodeComponent implements OnInit, AfterViewInit {

  @ViewChildren('input') firstipcontrol;

  formname: String = "Transpaymode";
  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  transpaymodeColl: any = [];
  transpaymodeBO: any = {};

  transpaymodeid: number = 0

  transpaymodeform = new FormGroup({
    transpaymodeid: new FormControl(0),
    transpaymode: new FormControl('', Validators.required),
    isdefault: new FormControl(false),
    inactive: new FormControl(false),
  });


  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.transpaymodeid = params.id
      }
    });

    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }


    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.transpaymodeform.reset();
      this.fnInitializeFormGroup();

      if (this.transpaymodeid > 0) {
        this.fngetTransPaymode();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.transpaymodeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  ngAfterViewInit()
  {
    this.loginService.fnSetFirstControlFocus('txtfirst');
  }
  fnInitializeFormGroup() {
    this.transpaymodeform.setValue({
      transpaymodeid: 0,
      transpaymode: '',
      isdefault: false,
      inactive: false
    })
  }

  //Get 
  fngetTransPaymode() {
    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();

    var data = {
      'transpaymodeid': this.transpaymodeid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getTransPaymode(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();
            this.transpaymodeColl = res.json().result;
            var editdata = this.transpaymodeColl[0];
            this.fnEditMode(editdata);
            this.transpaymodeBO=editdata;
          }
          else {
            this.fnHideProgress();
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try { if (this.saveloading) {
      return;
    }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.transpaymodeform.valid) { this.saveloading = true;

        //Check
        var data = {
          'transpaymodeid': this.transpaymodeid,
          'transpaymode': this.transpaymodeform.get('transpaymode').value,
          'isdefault': this.transpaymodeform.get('isdefault').value,
          'inactive': this.transpaymodeform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }


        this.appService.fnCheckTransPaymode(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var _checkresult = res.json().result[0].checkfield;

              if (_checkresult === "done") {
                if (this.transpaymodeform.get('transpaymodeid').value > 0) {
                  //Update 
                  this.fnSetTransPaymode(data);
                }
                else {
                  //Insert 
                  this.fnInsertTransPaymode(data);
                }
              }
              else {
                if (_checkresult === "name") { this.saveloading = false;

                  this.transpaymodeform.controls['transpaymode'].setErrors({ 'notfound': true });
                }
              }
            }
            else { this.saveloading = false;

              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => { this.saveloading = false;

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) { this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertTransPaymode(data) {

    this.appService.fnInsertTransPaymode(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new TransPaymode has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, data.transpaymode);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetTransPaymode(data) {

    this.appService.fnSetTransPaymode(data).subscribe(
      (res) => { this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The TransPaymode has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.transpaymodeid, data.transpaymode);
            this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => { this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/TransPaymode']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    this.transpaymodeform.setValue({
      transpaymodeid: deptBO.transpaymodeid,
      transpaymode: deptBO.transpaymode,
      isdefault: deptBO.isdefault,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch{

    }
  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }









}
